export const socketConstants = {
  JOIN: 'socket/JOIN',
  DISCONNECT: 'socket/DISCONNECT',
};
